export function getValidAiQueryLimit(limit, maxLimit) {
    if (!limit) {
        return maxLimit;
    }
    if (limit > maxLimit) {
        throw new Error(`The limit provided is greater than the maximum allowed limit of ${maxLimit}`);
    }
    return limit;
}
//# sourceMappingURL=validators.js.map